module.exports = __webpack_public_path__ + "img/twig_one.810f851b.png";